export function checkSignUpStringFormat(value: string) {
  return !/^(\p{L}+'?)+([ -](\p{L}+'?)+)*\s*$/gu.test(value);
}
